import { ProductBrand } from "..";

export interface ProductBrandDomain<TProductBrand extends ProductBrand> {
  Detail: TProductBrand;
  DomainId: string;
  ChildProductBrandIds: string[];
  ParentProductBrandName: string;
  ParentProductBrandId: string;
}
